export enum ProfileType {
    Primary = 'Primary Profile',
    Supporter = 'Supporting Profile',
    Spouse = 'Spouse Profile',
    DomesticPartner = 'Domestic Partner Profile',
    Dependent = 'Dependent Profile',
    Other = 'Other Profile'
}
